import { PulseBaseProvider } from '../../base-classes';
import orderBy from 'lodash.orderby';

const _storedLocationUri = '/api/push/notificationoptions/v1';
const _storedLocationListCacheKey = 'storedLocationList';

export class StoredLocationProvider extends PulseBaseProvider {

    static fmlId = '00000000-1111-0000-1111-000000000000';
    static fmlName = 'My Location';

    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);

        this.storage.sync[_storedLocationListCacheKey] = this.storedLocationListSyncer.bind(this);
    }

    async storedLocationListSyncer(params) {
        const { syncParams, resolve, reject, id } = params;
        let pathParams = { appinstanceid: syncParams.stdParameters.appInstanceId };
        if (syncParams.locationId && syncParams.notificationOptionsType) {
            pathParams.locationId = syncParams.locationId;
            pathParams.type = syncParams.notificationOptionsType;
        }
        let queryParams = {
            ...syncParams.stdParameters
            , verbose: syncParams.verbose
            , pathParams
        };
        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _storedLocationUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
        );
    }

    async getStoredLocationList(stdParameters, verbose, refresh = false, locationId, notificationOptionsType) {
        const syncParams = {
            verbose: !!verbose,
            locationId,
            notificationOptionsType
        };

        let idParams = {
            appInstanceId: stdParameters.appInstanceId
        };

        const id = JSON.stringify(idParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_storedLocationListCacheKey, id);
        }
        const response = await super.loadFromStorage(_storedLocationListCacheKey, id, syncParams);

        super.saveToStorage(_storedLocationListCacheKey, id, response.locationNotificationOptions);

        return response.locationNotificationOptions;
    }

    // Two variations of post calls.
    // POST /api/push/notificationoptions/v1/appinstanceid={{appinstanceid}}/locationid={{locationid}}?verbose=true
    // {
    //     "isNotificationEnabled": true
    // }

    //Response location set to NO alert
    // {
    //     "id": "0HLQ8A0VJULSF",
    //     "errorMessage": null,
    //     "result": {
    //       "appInstanceId": "8BB016F4-7701-4EE9-8114-BBE0D69F0C20",
    //       "locationNotificationOptions": [
    //         {
    //           "locationId": "00000000-1111-0000-1111-000000000000",
    //           "locationName": "Estacada, Oregon",
    //           "isNotificationEnabled": false,
    //           "isNotificationAvailable": true,
    //           "notificationOptions": [

    //           ]
    //         }
    //       ]
    //     },
    //     "code": 200
    //   }

    //Response location set to YES alert
    // {
    //     "id": "0HLQ8A0VJULSK",
    //     "errorMessage": null,
    //     "result": {
    //       "appInstanceId": "8BB016F4-7701-4EE9-8114-BBE0D69F0C20",
    //       "locationNotificationOptions": [
    //         {
    //           "locationId": "00000000-1111-0000-1111-000000000000",
    //           "locationName": "Estacada, Oregon",
    //           "isNotificationEnabled": true,
    //           "isNotificationAvailable": true,
    //           "notificationOptions": [
    //             {
    //               "notificationOptionsType": "WeatherAlerts",
    //               "isNotificationEnabled": true,
    //               "isNotificationAvailable": true,
    //               "caption": "Weather Alert",
    //               "summary": "A Weather Alert has been issued.",
    //               "iconCode": "WeatherAlert",
    //               "params": [

    //               ]
    //             },
    //             {
    //               "notificationOptionsType": "Lightning",
    //               "isNotificationEnabled": true,
    //               "isNotificationAvailable": true,
    //               "caption": "Lightning",
    //               "summary": "Lightning is nearby",
    //               "iconCode": "Lightning",
    //               "params": [

    //               ]
    //             },
    //             {
    //               "notificationOptionsType": "Pollen",
    //               "isNotificationEnabled": true,
    //               "isNotificationAvailable": true,
    //               "caption": "Pollen",
    //               "summary": "Pollen is elevated",
    //               "iconCode": "Pollen",
    //               "params": [

    //               ]
    //             },
    //             {
    //               "notificationOptionsType": "AirQuality",
    //               "isNotificationEnabled": true,
    //               "isNotificationAvailable": true,
    //               "caption": "Air Quality",
    //               "summary": "Air Quality is degraded",
    //               "iconCode": "AirQuality",
    //               "params": [

    //               ]
    //             }
    //           ]
    //         }
    //       ]
    //     },
    //     "code": 200
    //   }

    // POST /api/push/notificationoptions/v1/appinstanceid={{appinstanceid}}/locationid={{locationid}}/type={{notificationOptionsType}}?verbose=true
    // {
    // "isNotificationEnabled": true
    // }

    // Response -> changing one option
    // {
    //     "id": "0HLQ8A0VJULRO",
    //     "errorMessage": null,
    //     "result": {
    //       "appInstanceId": "8BB016F4-7701-4EE9-8114-BBE0D69F0C20",
    //       "locationNotificationOptions": [
    //         {
    //           "locationId": "00000000-1111-0000-1111-000000000000",
    //           "locationName": "Estacada, Oregon",
    //           "isNotificationEnabled": true,
    //           "isNotificationAvailable": true,
    //           "notificationOptions": [
    //             {
    //               "notificationOptionsType": "Pollen",
    //               "isNotificationEnabled": false,
    //               "isNotificationAvailable": true,
    //               "caption": "Pollen",
    //               "summary": "Pollen is elevated",
    //               "iconCode": "Pollen",
    //               "params": [

    //               ]
    //             }
    //           ]
    //         }
    //       ]
    //     },
    //     "code": 200
    //   }
    async updateStoredLocation(stdParameters, verbose, locationId, isNotificationEnabled, notificationOptionsType) {

        let queryParams = {
            verbose: !!verbose
        };

        let idParams = {
            appInstanceId: stdParameters.appInstanceId
        };

        const id = JSON.stringify(idParams);


        //this can be the high level isNotificationEnabled at location 
        // or inner level isNotificationEnabled for the alert
        let dataObject = {
            isNotificationEnabled: !!isNotificationEnabled
        };

        const data = JSON.stringify(dataObject);


        let pathParams;

        if (notificationOptionsType) {

            pathParams = {
                appinstanceid: stdParameters.appInstanceId,
                locationid: locationId,
                type: notificationOptionsType
            };

        }
        else {
            pathParams = {
                appinstanceid: stdParameters.appInstanceId,
                locationid: locationId
            };
        }

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        queryParams = {
            ...queryParams,
            ...stdParameters,
            pathParams
        };
        const response = await super.postData(queryParams, data, _storedLocationUri, true, null);

        //  The aim is to keep the post call return super fast. No need for it to return a location or complete list of locations.
        // The local storage is modified based on which alert the user turned off or on.
        // Response e.g. for the post call: {code: 200, responseTime: 1568936683776}

        let locationsList = await super.readFromStorage(_storedLocationListCacheKey, id);

        if (response) {
            //Find the location to be modified  in the list -> update local storage
            let changedLocation = locationsList.find(location => location.locationId === locationId);
            if (changedLocation) {
                if (notificationOptionsType) {
                    // update the options type with alert flag
                    const changedOption = changedLocation.notificationOptions.find(optionType => optionType.notificationOptionsType === notificationOptionsType);
                    if (changedOption) {
                        changedOption.isNotificationEnabled = isNotificationEnabled;
                    }
                } else {
                    //update the location with alert flag
                    changedLocation.isNotificationEnabled = isNotificationEnabled;
                    if (isNotificationEnabled) {
                        // The server config can return some option types as enabled or disabled, so use the response object to 
                        // repopulate this newly enabled location
                        const array = response.locationNotificationOptions;
                        const oneLocation = array[0];
                        changedLocation.notificationOptions = oneLocation.notificationOptions;
                    } else {
                        // toggle all options off if alert disabled at location level. This matches the server behaviour. 
                        changedLocation.notificationOptions.map(option => option.isNotificationEnabled = isNotificationEnabled);
                    }
                }
            }
            super.saveToStorage(_storedLocationListCacheKey, id, locationsList);

        }
        return locationsList;

    }
}

